export enum PROCESS_FILTER_CATEGORIES {
	PROGRAM_IDS = 'Program_Ids',
	APPLICATION = 'Application Filter'
}
